import { render, staticRenderFns } from "./pageModificationComponent.vue?vue&type=template&id=b7bf4f50&"
import script from "./pageModificationComponent.vue?vue&type=script&lang=js&"
export * from "./pageModificationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports